module.exports = __webpack_public_path__ + "static/assets/7deb41099be6d77fb833fcdf6eb1f1e4.png";